import{jsx as o}from"react/jsx-runtime";import{useNavigate as r}from"react-router-dom";import{styled as e}from"styled-components";import{useTab as t}from"../context/TabContext.mjs";import{useItemName as a}from"../../../../domain/hooks/useItemName.mjs";const m=e.div.attrs({className:"tab"})`
  margin-top: 4px;
  margin-right: 0.2em;
  border: 1px solid #d3d3d3;
  border-bottom: 0;
  border-radius: 2px;
  background: #e6e6e6;
  line-height: 1.3;

  a {
    cursor: pointer;
    float: left;
    padding: 0.5em 1em;
  }
  h2 {
    padding: 4px 3px 2px 0;
    margin: 0px;
    font-size: 15px;
    font-weight: normal;
    max-width: 400px;
  }

  &:hover {
    border: 1px solid #999999;
    border-bottom: 0;
    background-color: #dadada;
    color: #212121;
  }

  &.selected {
    background: url(images/tab.png) repeat-x;
    padding-bottom: 3px;
    border: 1px solid #aaaaaa;
    border-bottom: 1px solid white;
    margin-top: 0px;

    a {
      cursor: text;
    }
    h2 {
      color: #ffffff;
    }
  }
`;function d({label:e,value:d,subSystemName:i}){const n=a(),{currentTab:p}=t(),s=r();return o(m,{className:d===p?"selected":"",onClick:()=>s(`/${i}/main-menu?currentTab=${d}`),children:o("a",{children:o("h2",{children:n(e)})})})}export{d as Tab};
